<!--
@Author: Calvin Green <calvin>
@Date:   2022-01-11T13:51:01+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-02-01T10:43:40+02:00
@Copyright: Diversitude 2021
-->

<template>
    <Layout>
        <b-row>
            <b-col xl="2"  sm="3">
                <keep-alive>
                    <Menu @back="handleBack"/>
                </keep-alive>
            </b-col>
            <b-col xl="10"  sm="9">
                <Administration v-if="administration_view == 'administration'" />
                <Workflow v-if="administration_view == 'workflow'"/>
                <AuditLogs v-if="administration_view == 'audit_logs'"/>
            </b-col>
        </b-row>
    </Layout>
</template>

<script>

import Menu from '@/components/widgets/green-menu.vue'
import Layout from "../../layouts/main-stripped";
// child components
import Administration from '@/components/client_admin/administration/administration.vue'
import Workflow from '@/components/client_admin/administration/workflow.vue'
import AuditLogs from '@/components/client_admin/administration/auditLogs.vue'
import {layoutMethods, clientAdminMenuComputed} from '@/state/helpers';
export default {
    data:() => ({
        isEditing: false,
        isEditingClient: false,
        isNewDocument: false,
        hideMenu: false,

        showStats: false,
        showDistribution: false,
    }),
    components:{
        Layout,
        Menu,
        Administration,
        Workflow,
        AuditLogs
    },
    computed: {
        ...clientAdminMenuComputed,
    },
    methods: {
        ...layoutMethods,
        handleBack(){
            this.showDocumentsMenu();
            this.isEditing = false;
            this.isEditingClient = false;
            this.showStats = false;
            this.showDistribution = false;
        },
        showDocumentsMenu(){
            this.updateMenuType({
                type: 'documents',
                showMenu: true,
                showRoutes: false,
            })
        },
        showEditMenu(){
            this.hideMenu = false;
            this.updateMenuType({
                type: 'document_edit',
                showMenu: false,
                showRoutes: false,
            })
        },
    },
    mounted(){
        this.$nextTick(()=>{
            this.updateMenuType({
                type: 'clientadmin_administration',
                showMenu: true,
                showRoutes: false,
            })
        })
    },
    beforeDestroy(){
        this.updateMenuType({
            type: 'Nothing',
            showMenu: true,
            showRoutes: false,
        })
    },
}
</script>

<style>

</style>
